import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { InputComponent } from "../../shared/input/input.component";
import { ButtonComponent } from "../../shared/button/button.component";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { LayoutComponent } from "../../shared/layout/layout.component";
import { TitleComponent } from "../../shared/title/title.component";
import { GigyaService } from "../../services/gigya.service";
import { SpinnerComponent } from "../../shared/icons/spinner/spinner.component";
import { BreadcrumbComponent } from "../../shared/breadcrumb/breadcrumb.component";
import { PasswordService, PasswordApiError } from "../../services/password.service";
import { PasswordRequirementsComponent } from "../../shared/password-requirements/password-requirements.component";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.css"],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    InputComponent,
    ButtonComponent,
    RouterLink,
    LayoutComponent,
    TitleComponent,
    BreadcrumbComponent,
    PasswordRequirementsComponent,
    SpinnerComponent,
  ],
})
export class ResetPasswordComponent implements OnInit {
  passwordForm: FormGroup;
  validations = { minLength: false, uppercase: false, number: false, specialChar: false };
  button_clicked = false;
  submitting = false;
  token: string | null = null;
  tokenValid: boolean | null = null;
  apiError: PasswordApiError | null = null;
  success = false;

  constructor(
    private fb: FormBuilder,
    private gigyaService: GigyaService,
    private route: ActivatedRoute,
    private passwordService: PasswordService,
  ) {
    this.passwordForm = this.fb.group({
      newPassword: ["", [Validators.required, this.passwordService.validator()]],
      confirmPassword: ["", [Validators.required]],
    });
    this.passwordForm.get("newPassword")?.valueChanges.subscribe(() => {
      if (this.apiError) {
        this.button_clicked = false;
        this.apiError = null;
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.token = this.route.snapshot.queryParamMap.get("pwrt");
    if (!this.token) {
      this.tokenValid = false;
      return;
    }
    const res = await this.gigyaService.execute(this.gigyaService.client.accounts.password.validateResetToken, {
      passwordResetToken: this.token,
    });
    this.tokenValid = res['isValidToken'] === true;
  }

  get passwordMismatch(): boolean {
    const newPassword = this.passwordForm.get("newPassword")?.value;
    const confirmPassword = this.passwordForm.get("confirmPassword")?.value;
    return newPassword && confirmPassword && newPassword !== confirmPassword;
  }

  checkPassword() {
    const control = this.passwordForm.get("newPassword");
    this.validations = this.passwordService.checkStrength(control?.value || "");
    control?.updateValueAndValidity({ emitEvent: false });
  }

  async onSubmit() {
    if (!this.passwordForm.valid || this.passwordMismatch) return;

    this.apiError = null;
    this.success = false;
    this.button_clicked = true;
    this.submitting = true;

    const res = await this.gigyaService.execute(this.gigyaService.client.accounts.resetPassword, {
      newPassword: this.passwordForm.get("newPassword")?.value,
      passwordResetToken: this.token,
    });

    this.submitting = false;
    if (res.errorCode === 0) {
      this.success = true;
      return;
    }
    this.button_clicked = false;
    this.apiError = this.passwordService.parseError(res);
  }
}
